import React from 'react';
import { Typography, Grid } from '@mui/material';
import { EventDetail } from '../../types';

interface EventDescriptionProps {
    event: EventDetail;
}

const EventDescription: React.FC<EventDescriptionProps> = ({ event }) => {
    return (
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
                Event Description
            </Typography>
            <Typography paragraph>{event.description}</Typography>
            <hr />
        </Grid>
    );
};

export default EventDescription;